module.exports = {
    language: 'language',
    direction: 'direction',
    isLoading: 'isLoading',
    isLoggedIn: 'isLoggedIn',
    showLogin: 'showLogin',
    showSignup: 'showSignup',
    allowSignups: 'allowSignups',
    showSimilarAds: 'showSimilarAds',
    showAnnouncementBar: 'showAnnouncementBar',
    announcement: 'announcement',
    maintenanceMode: 'maintenanceMode',
    maintenanceMessage: 'maintenanceMessage',
    showResetPassword: 'showResetPassword',
    user: 'user',
    cookie: 'cookie',
    token: 'token',
    currentLocation: 'currentLocation',
    startConversation: 'startConversation',
    usersCityId: 'usersCityId',
    searchCityId: 'searchCityId',
    searchCategory: 'searchCategory',
    searchCategoryId: 'searchCategoryId',
    searchKeyword: 'searchKeyword',
    searchCategories: 'searchCategories',
    searchTypes: 'searchTypes',
    searchPriceMin: 'searchPriceMin',
    searchPriceMax: 'searchPriceMax',
    searchBrands: 'searchBrands',
    selectedRegion: 'selectedRegion',
    cart: 'cart',
    counter: 'counter',
    deliveryAddress: 'deliveryAddress',
    cookiesAccepted: 'cookiesAccepted',
    openCategoriesCollapsible: 'openCategoriesCollapsible'
}